export function carryUpdate({ type, stateKey, updateOptions }) {

    return (nextSettings) =>
        updateOptions({
            type,
            stateKey,
            settings: nextSettings
        })
}